import React from 'react';
import { CardOptionsView } from '../../../Components/CardOptionsView/CardOptionsView';
import {
  CardOptionButton,
  CardOptionButtonProps
} from '../../../Components/CardOptionButton/CardOptionButton';
import { useHistory } from 'react-router-dom';

interface CardOptionButtonCmd extends CardOptionButtonProps {
  id?: string;
}

export interface CommandProps {
  path: string;
}

export const Command = ({
  path
}: CommandProps): React.ReactElement<CommandProps> => {
  const history = useHistory();

  const cards: CardOptionButtonCmd[] = [
    {
      label: 'Projects',
      icon: 'Projects-Solid',
      onClick: () => history.push(`${path}/projects`)
    }
  ];

  cards.sort((a, b) => a.label.localeCompare(b.label));

  return (
    <CardOptionsView>
      {cards.map((card) => (
        <CardOptionButton
          key={`${card.label}${card.id ? '-' + card.id : ''}`}
          label={card.label}
          icon={card.icon}
          onClick={card.onClick}
        />
      ))}
    </CardOptionsView>
  );
};
